import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import Vue from "vue";
import App from "./App.vue";
import { i18n } from "./locales/i18n";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

Vue.config.productionTip = false;

globalThis.equ = {
  log:
    process.env.NODE_ENV !== "production"
      ? console.log.bind(console)
      : () => {
          // do nothing
        },
};

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
